


















































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import { PayApi,yun,ShipManagementApi } from '@/http';
import publicFunc from '../../common/util/publicFunc';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        DataPanel,
        SearchPanel,
        PaginationPanel,
        DraggerImg,
        collapse,
        ListFilterPanel,
    },
})
export default class PayManagement extends Vue {
    public publicFunc = publicFunc;
    public searchValue: PayApi.GetFeeBillListPayload = {
        feeBillStatus:'',
        feeBillCode: '',
        cycle:'',
        customerBaseName:'',
        customerBaseId: '',
        carrierName: '',
        carrierId: '',
        creationStartTime: '',
        creationEndTime: '',
        asc: true,
        orderBy: ''
    };
    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
        formData: HTMLFormElement;
    };
    public dialogVisible: boolean = false;

    public formData: PayApi.AddFeeBillVM = {
        carrierId:'',
        carrierName: '',
        customerBaseId: '',
        customerBaseName: '',
        cycle:[]
    };

    public formRules = formRules;

    public shipStateType = enums.auditStatusEnum;

    public isActive: boolean = false;

    public loading: boolean = false;

    public rePagin: boolean = false;

    public total: number = 0;

    public tableData:Array<PayApi.FeeBillItemListVM> = [];
    /**
     * 获取费用类型
     */
    public feeTypeList = [];

    public accountDateList = [];

    public departmentlist = [];

    public timeList = [];
    public created() {}
    public mounted() {
         if (sessionStorage.getItem('PayStatement_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('PayStatement_searchValue'));
            this.timeList = [this.searchValue.creationStartTime, this.searchValue.creationEndTime];
            this.searchPagin = sessionStorage.getItem('PayStatement_page')
                ? JSON.parse(sessionStorage.getItem('PayStatement_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('PayStatement_page')
                ? JSON.parse(sessionStorage.getItem('PayStatement_page'))
                : this.searchPagin;

            this.loadData();
        }
    }
    public colData = JSON.parse(localStorage.getItem('PayStatement'))
        ? JSON.parse(localStorage.getItem('PayStatement'))
        : [     
              { title: '账单编号', isShow: true, disabled: false },
              { title: '对账周期', isShow: true, disabled: false },
              { title: '客户/基地名称', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '账单总金额（元）', isShow: true, disabled: false },
              { title: '含税金额（元）', isShow: true, disabled: false },
              { title: '油卡（元）', isShow: true, disabled: false },
              { title: '客诉（元）', isShow: true, disabled: false },
              { title: '雨布（元）', isShow: true, disabled: false },
              { title: '其他（元）', isShow: true, disabled: false },
              { title: '账单状态', isShow: true, disabled: false },
              { title: '创建方', isShow: true, disabled: false },
              { title: '创建人', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('PayStatement', JSON.stringify(this.colData));
    }
    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
        sessionStorage.setItem('PayStatement_searchValue', JSON.stringify(this.searchValue));
    }

    public toSkip(row){
        sessionStorage.setItem('PayStatement_page', JSON.stringify(this.searchPagin));
        this.$router.push({
            path: '/PaystatementDetails',
            query: {
                id: row.id,
            },
        });
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
         sessionStorage.setItem('PayStatement_page', JSON.stringify(pagin));
        this.loadData();
    }
    public resetSearchValue() {
        this.searchValue = {
            feeBillStatus:'',
            feeBillCode: '',
            cycle:'',
            customerBaseName:'',
            customerBaseId: '',
            carrierName: '',
            carrierId: '',
            creationStartTime: '',
            creationEndTime: '',
            asc: true,
            orderBy: ''
        };
        this.timeList = [];
        this.searchFunc()
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'creationTime':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
        }
        this.loadData();
    }
    public async loadData() {
        this.loading = true;
        try {
          let skip = this.searchPagin.skip;
          let res = await PayApi.GetFeeBillList({
              ...this.searchValue,
              skip: skip,
              count: this.searchPagin.count
          });
          this.tableData = res.data;
          this.$refs.pagination.setPage(this.searchPagin.currentPage);
          this.tableData.map((item,index)=>{
              item.index = skip++ + 1;
          });
          this.total = res.total;
          this.loading = false;
            /**无数据返回上一页 */
          if (this.searchPagin.currentPage > 1) {
            if (this.tableData.length == 0) {
                this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
            }
          }
        } catch (error) {
          this.loading = false;
        } 
    }
    public datetimerange(v) {
        if (v) {
            this.searchValue.creationStartTime = v[0];
            this.searchValue.creationEndTime = v[1];
        } else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
        }
    }
    public datetimerange2(value) {
        if (value) {
            let MM = value.getMonth() + 1;
            if (MM < 10) {
                MM = '0' + MM;
            }
            this.searchValue.cycle = value.getFullYear() + '-' + MM;
        } else {
            this.searchValue.cycle = null;
        }
    }
    /**新增对账单 */
    public datetimerangeChange(value) {
        this.formData.cycle = [];
        if (value) {
            this.getMonthBetween(value[0], value[1]);
            console.log(this.formData.cycle);
        } else {
            this.formData.cycle = [];
        }
    }
    //获取两月份之间所有月份方法
    getMonthBetween(start, end) {
        var result = [];
        var newResult = [];
        var starts = start.split('-');
        var ends = end.split('-');
        var staYear = parseInt(starts[0]);
        var staMon = parseInt(starts[1]);
        var endYear = parseInt(ends[0]);
        var endMon = parseInt(ends[1]);
        while (staYear <= endYear) {
            if (staYear === endYear) {
                while (staMon < endMon) {
                    staMon++;
                    result.push({ year: staYear, month: staMon });
                }
                staYear++;
            } else {
                staMon++;
                if (staMon > 12) {
                    staMon = 1;
                    staYear++;
                }
                result.push({ year: staYear, month: staMon });
            }
        }

        for (var i = 0; i < result.length; i++) {
            var year = result[i].year;
            var monthinit = result[i].month;
            var month = monthinit;
            //补'0'操作
            if (monthinit < 10) {
                month = '0' + monthinit;
            } else {
                month = monthinit + '';
            }
            var ym = year + '-' + month;
            this.formData.cycle.push(ym);
        }
        this.formData.cycle.unshift(start);
        return this.formData.cycle;
    }

        selectList = [];
    async querySearch1(queryString, cb) {
        this.formData.carrierId = '';
        this.formData.customerBaseId = '';
        this.formData.customerBaseName = '';
        this.shipperList = [];
        let res = await yun.GetCarrierList({ Name: this.formData.carrierName, count: -1 });
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    shipperList= [];
   async selectCar1(data) {
        this.formData.carrierId = data.id;
          let res = await ShipManagementApi.GetShipperByCarrier(data.id);
          console.log('res',res);
          
          this.shipperList = res;
    }
    handleSearch(data){
        this.formData.customerBaseId = data;
        this.shipperList.forEach(v=>{
            if(v.id==this.formData.customerBaseId){
                this.formData.customerBaseName = v.name;
            }
        })
    }

    public addBtn() {
        this.formData = {
            carrierId:'',
            carrierName: '',
            customerBaseId: '',
            customerBaseName: '',
            cycle:[]
        }
        this.accountDateList = [];
        this.dialogVisible = true;
    }
    public handleClose() {
        this.$refs.formData.resetFields();
        this.dialogVisible = false;
    }
    public save() {
         this.$refs.formData.validate(async (valid) => {
             if(valid){
                 PayApi.AddFeeBill({
                    carrierId:this.formData.carrierId,
                    customerBaseId: this.formData.customerBaseId,
                    Cycle:this.formData.cycle
  
                 }).then(res=>{
                    this.dialogVisible = false;
                    console.log(res);
                    
                     this.$router.push({
                            path: '/PaystatementDetails',
                            query: {
                                id: res.extData,
                            },
                        });
                 })
                 
             }
         })
    }
    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig.show = false;
    }
        /**通过 */
    public srow: any;
    public srowTy: string = '';
    public setColor: boolean = false;
    through(row) {
        this.setColor = false;
        this.srow = row;
        this.srowTy = 'a';
        this.dialogConfig = {
            title: '审核通过对账单',
            show: true,
        };
    }
    toBack(row) {
        this.setColor = true;
        this.srow = row;
        this.srowTy = 'b';
        this.dialogConfig = {
            title: '退回对账单',
            show: true,
        };
    }
     async confirmOk() {
        if (this.srowTy == 'a') {
           PayApi.UpdateBillStatus({ id: this.srow.id, feeBillStatus: '4' }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '账单审核通过！',
                    });
                     this.loadData();
                    this.dialogConfig.show = false;
                });
        } else if (this.srowTy == 'b') {
            PayApi.UpdateBillStatus({ id: this.srow.id, feeBillStatus: '3' }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '账单退回成功！',
                    });
                     this.loadData();
                    this.dialogConfig.show = false;
                });
        }
    }
    public getBillColor(val) {
        switch (val) {
            case '待审核':
                return 'c_blue';
            case '审核退回':
                return 'c_gray';
            case '已审核':
                return 'c_green';

            default:
                break;
        }
    }
    public async exportExcel() {
        let data = await PayApi.Feebilllistexport({
              ...this.searchValue,
              skip: this.searchPagin.skip,
              count: this.searchPagin.count
        });
    }

    selectList2 = [];
    async querySearch2(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    selectCar2(data) {
        this.searchValue.carrierName = data.value;
    }
    
}
